module.exports = __webpack_public_path__ + "static/media/Pelvis_Subchondral.7dd07258.png";